// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"283f760c","749":"2f9c64d3","903":"254d9733"}[chunkId] + ".chunk.js";
};